module.exports = __webpack_public_path__ + "static/media/入試相談室.3b85b6f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/exhibition/入試相談室.png
// module id = 315
// module chunks = 10